<template>
  <div></div>
</template>

<script>
import { interact } from "fire-wind-water/tools/interact";

export default {
  name: "Home",
  created() {
    if (interact.isMobile == 1) {
      window.location.hash = "#/wap";
    } else {
      window.location.hash = "#/pc";
    }
  }
};
</script>
